import { render, staticRenderFns } from "./InternalMenu.vue?vue&type=template&id=1d29babb&scoped=true"
import script from "./InternalMenu.vue?vue&type=script&lang=js"
export * from "./InternalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d29babb",
  null
  
)

export default component.exports